export default __webpack_public_path__ + "static/media/66.bc5938a2.png";